import { styled } from '@mui/material/styles';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { PropsWithChildren } from 'react';

type IProps = Pick<TypographyProps, 'sx'>;

const StyledTitle = styled(Typography)`
    text-align: center;
`;

export const DrawerTitle = ({ children, ...rest }: PropsWithChildren<IProps>) =>
    children ? (
        <StyledTitle {...rest} variant="h5">
            {children}
        </StyledTitle>
    ) : null;
